import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1cb9d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-shipping" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " We are unable to deliver to a PO Bo ", -1))
const _hoisted_3 = { class: "box-submit" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save This Address? ")

import { ref, computed } from 'vue';
  import InfoAddress from './info-address.vue';
  import { ColorVariants } from '@/constants';
  import { CheckoutStore } from '@/stores';

  interface IProps {
    store: CheckoutStore
  }

  interface IEmits {
    (event: 'submit'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  emits: ["submit"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'submit'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    store: CheckoutStore
  }

  
  
  const saveAddressToServerCheckbox = ref(true);
  const saveAddressToServer = computed(() => props.store.address_id === 0 && saveAddressToServerCheckbox.value);

  async function handleSubmit() {
    await props.store.setSaveAddrss(saveAddressToServer.value);
    emits('submit');
  }


return (_ctx: any,_cache: any) => {
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InfoAddress, { store: __props.store }, null, 8, ["store"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppLoadingButton, {
        class: "btn-submit",
        pill: "",
        variant: _unref(ColorVariants).primary,
        disabled: __props.store.address_id === null,
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(saveAddressToServer) ? 'Save and Continue' : 'Continue'), 1)
        ]),
        _: 1
      }, 8, ["variant", "disabled"]),
      (__props.store.address_id === 0)
        ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
            key: 0,
            modelValue: saveAddressToServerCheckbox.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((saveAddressToServerCheckbox).value = $event)),
            class: "checkbox"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})